import { render, staticRenderFns } from "./ElAsmenysList.vue?vue&type=template&id=257df1cb&scoped=true&"
import script from "./ElAsmenysList.vue?vue&type=script&lang=js&"
export * from "./ElAsmenysList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257df1cb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
